import React, { useEffect, useState } from "react";
import HeaderCustom from "../../components/header/HeaderCustom";
import { ButtonStyleAzul, ButtonStyleWhite, CentrarDiv, CustomBackdrop, DivBackgroundDasboard, MaxDiv, PaperStyle, TEXT_COLOR_AZUL_OSCURO, TEXT_COLOR_CELESTE, TypographyStyleSecundary } from "../../styles/Styles";
import { Alert, Backdrop, Button, CircularProgress, Container, CssBaseline, IconButton, InputAdornment, Paper, Snackbar, Typography, ListItem, ListItemButton, ListItemText, TextField, List, ListSubheader, ListItemIcon, Switch } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setToken } from "../../redux/actions/action";
import { ButtonFlotante } from "../../components/botonQr/ButtonFlotante";
import { FingerprintOutlined, TagFacesOutlined } from "@mui/icons-material";

const SeguridadPage = (props) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [mensaje, setMensaje] = useState('');
    const [cargando, setCargando] = useState('');
    const [checkedBiometric, setCheckedBiometric] = useState(localStorage.getItem('biometric') ? true : false);
    const [checkedFacial, setCheckedFacial] = useState(false);




    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log('satate', stateToken);

    let history = useNavigate();

    const dispatch = useDispatch();

    const handleToggle = () => () => {
        setCheckedBiometric(!checkedBiometric);
        if (!checkedBiometric) {
            localStorage.setItem('biometric', 'true');

            let dataStorage = localStorage.getItem('dataAutenticacion');
            let type = JSON.parse(dataStorage);
            // console.log('dataStorage', dataStorage);

            try {
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'dataAutenticacion', data: type }));
            } catch (e) {
                console.error('Error en dataAutenticacion:', e);
            }

        } else {
            try {
                localStorage.removeItem('biometric');
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'removeDataAutenticacion', data: null }));
            } catch (e) {
                console.error('Error en dataAutenticacion:', e);
            }
        }
    }

    const handleToggleFacial = (value) => () => {
        const currentIndex = checkedFacial.indexOf(value);
        const newChecked = [...checkedFacial];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setCheckedFacial(newChecked);
    }








    return (
        <div>
            <HeaderCustom title="Perfil">
                <MaxDiv>
                    <PaperStyle>
                        <TypographyStyleSecundary component="h5" variant="h5" align='center' style={{}}>
                            Seguridad
                        </TypographyStyleSecundary>

                        <List
                            sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                        // subheader={<ListSubheader sx={{
                        //     fontSize: '1.2rem',
                        //     fontWeight: 'bold',
                        //     color: TEXT_COLOR_AZUL_OSCURO,
                        //     textAlign: 'center',
                        // }}>Seguridad</ListSubheader>}
                        >
                            <ListItem>
                                <ListItemIcon>
                                    <FingerprintOutlined />
                                </ListItemIcon>

                                <ListItemText
                                    id="switch-list-label-wifi"
                                    primary="Habilitar autenticación biométrica"
                                />
                                <Switch
                                    edge="end"
                                    onChange={handleToggle()}
                                    // checked={checked.indexOf('wifi') !== -1}
                                    // onChange={e => setCheckedBiometric(e.target.checked)}
                                    checked={checkedBiometric}
                                    inputProps={{
                                        'aria-labelledby': 'switch-list-label-wifi',
                                    }}
                                />
                            </ListItem>
                            {/* <ListItem>
                                <ListItemIcon>
                                    <TagFacesOutlined />
                                </ListItemIcon>
                                <ListItemText 
                                id="switch-list-label-bluetooth" 
                                primary="Habilitar reconocimiento facial" 
                                />
                                <Switch
                                    edge="end"
                                    // onChange={handleToggle('bluetooth')}
                                    // checked={checked.indexOf('bluetooth') !== -1}
                                    onChange={handleToggleFacial}
                                    checked={checkedFacial}
                                    inputProps={{
                                        'aria-labelledby': 'switch-list-label-bluetooth',
                                    }}
                                />
                            </ListItem> */}
                        </List>



                    </PaperStyle>



                    {/*agregar boton flotante*/}
                    <ButtonFlotante />
                </MaxDiv>
            </HeaderCustom>

            <CustomBackdrop open={cargando}>
                <CircularProgress color="inherit" />
            </CustomBackdrop>
        </div>
    )
}

export default SeguridadPage;